/* Nividas PDP Sun / Prescription toggle — rx-spec-v3.md §6, §9.

   The frame is one product in both states (§1 rules out a duplicate
   "optical" version), so this switches the *view*: which image set shows,
   which price shows, and whether the button adds to cart or continues into
   the Rx configurator.

   Only renders where custom.rx_available is true, so this script no-ops on
   every other product. */

(function () {
  'use strict';

  function init(toggle) {
    if (!toggle || toggle.dataset.nvBound === '1') return;
    toggle.dataset.nvBound = '1';

    var buttons = toggle.querySelectorAll('[data-rx-state]');
    var rxNote  = document.querySelector('[data-nv-rx-note]');

    // Relabel the real Add to cart button rather than swapping in a
    // look-alike link. An earlier version rendered a separate <a> with the
    // button's classes, which picked up link hover styling and stopped
    // matching the button it replaced.
    var atcForm     = document.querySelector('.nv-pdp-atc__form');
    var atcLabel    = document.querySelector('[data-add-to-cart-text]');
    var atcPrice    = document.querySelector('[data-nv-atc-price]');
    var atcLabelSun = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';

    var rxUrl     = toggle.getAttribute('data-rx-url') || '';
    var rxCtaText = toggle.getAttribute('data-rx-cta') || 'Choose lenses';

    // The sticky bar is a separate component with its own label, price and
    // add-to-cart handler. Without this it kept offering to add the bare
    // frame while the page above was showing the prescription price.
    var sticky      = document.querySelector('[data-nv-pdp-sticky]');
    var stickyLabel = document.querySelector('[data-nv-pdp-sticky-label]');
    var stickyBtn   = document.querySelector('[data-nv-pdp-sticky-btn]');
    var stickyLabelSun = stickyLabel ? stickyLabel.textContent.trim() : 'Add to cart';

    var isRx = false;

    // Display twin (template suffix rx-twin): the page IS the prescription
    // product, so it is locked in the Prescription view. The toggle element
    // is rendered hidden and only carries the data; the URL and the colour
    // links are left alone.
    var forced = toggle.hasAttribute('data-rx-forced');

    // Reading glasses as prescription frames (Bilbao, 2026-10-15): clear
    // prescription lenses only. The plain page is the readers page and links
    // to the prescription glasses page; that page links back to the readers.
    var reader = toggle.hasAttribute('data-rx-reader');

    // Which finish the configurator should open on. Overridden by ?lens=
    // further down; Clear is the default because that is what the plain
    // Prescription toggle means.
    var rxFinish = 'clear';

    // No-strength route, from the Blue light glasses and Glasses without
    // strength cards (?strength=none, ?bluelight=yes with ?lens=clear).
    // Prices the pair accordingly and is handed on to the configurator,
    // which opens with those answers marked. Dropped when the customer
    // switches to Sunglasses.
    //   ''  → ordinary prescription view
    //   'none' / 'bluelight'
    var rxRoute = '';

    // Clear-lens photography may not exist yet. Falling back to the sun
    // images is better than switching to an empty gallery — the rest of the
    // Rx state (price, CTA) still works, so the path stays usable while the
    // photography is being produced.
    var hasClearSet = document.querySelectorAll('[data-lens-set="clear"]').length > 0;

    function showImageSet(which) {
      if (!hasClearSet) return;
      document.querySelectorAll('[data-lens-set]').forEach(function (cell) {
        cell.hidden = cell.dataset.lensSet !== which;
      });
      // The gallery sizes itself from visible cells, so it has to re-measure
      // after a swap or the pager keeps the old page count.
      document.dispatchEvent(new CustomEvent('nv:gallery:refresh'));
    }

    // Prescription view price: frame + the cheapest lens on offer for the
    // current route (clear, or sun via ?lens=sun). Every price element that
    // carries data-frame-cents is re-rendered from it, so the headline and
    // the sticky bar always agree. Exposed so the variant scripts can call it
    // after they write a new frame price.
    var addClear = parseInt(toggle.getAttribute('data-rx-add-clear'), 10) || 0;
    var addSun = parseInt(toggle.getAttribute('data-rx-add-sun'), 10) || addClear;
    var addBl = parseInt(toggle.getAttribute('data-rx-add-bl'), 10) || 0;

    // Query string for the route, shared by the configurator link and the
    // colour links.
    function routeParams() {
      if (rxRoute === 'none') return { strength: 'none' };
      if (rxRoute === 'bluelight') return { strength: 'none', bluelight: 'yes' };
      return {};
    }
    var currency = toggle.getAttribute('data-currency') || 'SEK';

    function money(cents) {
      var whole = Math.floor(cents / 100), rem = cents % 100;
      // Thousands grouped with a comma, like the store's money format.
      return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (rem ?'.' + (rem < 10 ? '0' : '') + rem : '') + ' ' + currency;
    }

    function renderPrices() {
      var add = isRx ? (rxFinish === 'clear' ? addClear : addSun) : 0;
      if (isRx && rxRoute === 'bluelight') add += addBl;
      document.querySelectorAll('[data-nv-pdp-price-current][data-frame-cents], [data-nv-pdp-sticky-price][data-frame-cents]').forEach(function (el) {
        var frame = parseInt(el.getAttribute('data-frame-cents'), 10);
        if (!isNaN(frame)) el.textContent = money(frame + add);
      });
      // Main button's price line (2026-10-15: every buy button shows its
      // price under the action) — "from …" while lenses are still to be
      // chosen, the plain frame price when it goes straight to the cart.
      if (atcPrice) {
        atcPrice.hidden = false;
        atcPrice.textContent = (isRx ? 'from ' : '') + money(frameCents() + add);
      }
      renderAlt();
      if (rxNote) {
        var noteKey = rxRoute || (rxFinish === 'clear' ? 'clear' : 'sun');
        rxNote.querySelectorAll('[data-rx-finish]').forEach(function (s) {
          s.hidden = s.getAttribute('data-rx-finish') !== noteKey;
        });
      }
    }
    window.nvRxRenderPrices = renderPrices;

    // Selected size → the same size on the real frame, as
    // "<variant here>:<frame variant>," pairs. Without it the configurator
    // opened on the first available size whatever had been picked here.
    var rxVariants = {};
    (toggle.getAttribute('data-rx-variants') || '').split(',').forEach(function (pair) {
      var p = pair.split(':');
      if (p.length === 2 && /^\d+$/.test(p[0]) && /^\d+$/.test(p[1])) rxVariants[p[0]] = p[1];
    });

    // `finishOverride`: the sunglasses page's "Choose prescription lenses" opens
    // the configurator in sunglasses mode while the page itself stays in its
    // sunglasses (no prescription) state.
    function ctaUrl(finishOverride) {
      if (!rxUrl) return '';
      var url = rxUrl + (rxUrl.indexOf('?') === -1 ? '?' : '&') + 'finish=' + (finishOverride || rxFinish);
      var select = document.querySelector('.nv-pdp-atc__form [name="id"]');
      var frameVariant = select ? rxVariants[select.value] : '';
      if (frameVariant) url += '&variant=' + frameVariant;
      var rp = routeParams();
      Object.keys(rp).forEach(function (k) { url += '&' + k + '=' + rp[k]; });
      return url;
    }

    /* ---------- the other way to buy (no switch, 2026-10-15) ----------
       The page keeps the tint it was opened with; this second button and
       link offer the other options:
         sun   (no ?lens)  [Choose prescription lenses · from frame+sun lens]
                           + Also as prescription glasses, from …
         rxsun (?lens=sun) Choose lenses is the main button; this one is
                           [Add without prescription · frame] (adds the frame)
                           + Also as prescription glasses, from …
         clear (?lens=clear)  Also as prescription sunglasses, from …
                           (no strength / blue light: Also available as sunglasses)          */
    var alt = document.querySelector('[data-nv-rx-alt]');
    var altBtn = alt ? alt.querySelector('[data-nv-rx-alt-btn]') : null;
    var altLink = alt ? alt.querySelector('[data-nv-rx-alt-link]') : null;
    // Set for the moment the rxsun "Add to cart" submits the form, so the
    // submit is not sent to the configurator like Choose lenses.
    var bypassRx = false;

    function frameCents() {
      var el = document.querySelector('[data-nv-pdp-price-current][data-frame-cents]');
      var n = el ? parseInt(el.getAttribute('data-frame-cents'), 10) : NaN;
      return isNaN(n) ? 0 : n;
    }

    function pageUrl(lensValue) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('strength');
        u.searchParams.delete('bluelight');
        if (lensValue) u.searchParams.set('lens', lensValue); else u.searchParams.delete('lens');
        return u.pathname + u.search;
      } catch (e) { return window.location.pathname + (lensValue ? '?lens=' + lensValue : ''); }
    }

    function sizeAvailable() {
      var sel = document.querySelector('.nv-pdp-atc__form [name="id"]');
      var opt = sel && sel.options[sel.selectedIndex];
      return !(opt && opt.disabled);
    }

    function renderAlt() {
      if (!alt || !altBtn || !altLink || forced) return;
      var f = frameCents();
      var mode = !isRx ? 'sun' : (rxFinish === 'clear' ? 'clear' : 'rxsun');
      alt.setAttribute('data-mode', mode);
      if (reader) {
        altBtn.hidden = true;
        if (mode === 'sun') {
          altLink.textContent = 'Also as prescription glasses, from ' + money(f + addClear);
          altLink.setAttribute('href', pageUrl('clear'));
        } else {
          altLink.textContent = 'Also available as readers, ' + money(f);
          altLink.setAttribute('href', pageUrl(null));
        }
        altLink.hidden = false;
        return;
      }
      // Cross-links (Jakob 2026-10-15): always name "prescription" and lead to
      // the prescription version of the other tint. A prescription glasses
      // page links to prescription sunglasses — not to the 995 sunglasses,
      // which read as prescription sunglasses for 995. No-strength and blue
      // light glasses (no prescription) keep the link to the sunglasses.
      if (mode === 'clear') {
        altBtn.hidden = true;
        if (rxRoute === 'none' || rxRoute === 'bluelight') {
          altLink.textContent = 'Also available as sunglasses, ' + money(f);
          altLink.setAttribute('href', pageUrl(null));
        } else {
          altLink.textContent = 'Also as prescription sunglasses, from ' + money(f + addSun);
          altLink.setAttribute('href', pageUrl('sun'));
        }
        altLink.hidden = false;
        return;
      }
      // Calls to action whose verb says what happens (Jakob 2026-10-15):
      // "Choose" opens the lens choice, "Add" puts it in the cart — like the
      // main buttons. Two lines by design: the action, then the exact price
      // as a small line, so it never wraps by accident on a phone.
      var cta, price;
      if (mode === 'sun') { cta = 'Choose prescription lenses'; price = 'from ' + money(f + addSun); }
      else if (sizeAvailable()) { cta = 'Add without prescription'; price = money(f); }
      else { cta = 'Sold out'; price = ''; }
      altBtn.textContent = '';
      var ctaEl = document.createElement('span');
      ctaEl.className = 'nv-pdp-rxalt__cta';
      ctaEl.textContent = cta;
      altBtn.appendChild(ctaEl);
      if (price) {
        var priceEl = document.createElement('span');
        priceEl.className = 'nv-pdp-rxalt__price';
        priceEl.textContent = price;
        altBtn.appendChild(priceEl);
      }
      altBtn.disabled = mode === 'rxsun' && !sizeAvailable();
      altBtn.hidden = false;
      altLink.textContent = 'Also as prescription glasses, from ' + money(f + addClear);
      altLink.setAttribute('href', pageUrl('clear'));
      altLink.hidden = false;
    }

    /* Middle breadcrumb follows the view (2026-10-15). Without a collection in
       the address it fell back to the product type ("Sunglasses") on every
       view — e.g. a glasses page opened from the cart offer read
       Home / Sunglasses / Paris. Glasses → the prescription collection (or
       no-strength / blue light on those routes); prescription sunglasses →
       theirs; sunglasses keep where they came from unless that was a
       prescription collection. Desktop and mobile crumbs alike. */
    function crumbFor(key) {
      var v = toggle.getAttribute('data-crumb-' + key) || '';
      var i = v.lastIndexOf('|');
      if (i < 1) return null;
      var title = v.slice(0, i), url = v.slice(i + 1);
      return title && url ? { title: title, url: url } : null;
    }
    function renderCrumb() {
      var mids = document.querySelectorAll('[data-nv-crumb-mid]');
      if (!mids.length) return;
      var key = !isRx ? 'sun'
        : (rxFinish !== 'clear' ? 'rxsun' : (rxRoute === 'none' ? 'none' : (rxRoute === 'bluelight' ? 'bluelight' : 'clear')));
      var target = crumbFor(key);
      if (key === 'sun') {
        var rxUrls = ['clear', 'rxsun', 'none', 'bluelight'].map(function (k) { var c = crumbFor(k); return c ? c.url : null; });
        var current = mids[0].getAttribute('href');
        if (rxUrls.indexOf(current) === -1) return; // came from a sunglasses collection: keep it
      }
      if (!target) return;
      mids.forEach(function (a) { a.textContent = target.title; a.setAttribute('href', target.url); });
    }

    if (altBtn) {
      altBtn.addEventListener('click', function () {
        var mode = alt.getAttribute('data-mode');
        if (mode === 'sun') { window.location.href = ctaUrl('sun'); return; }
        if (mode === 'rxsun' && atcForm && sizeAvailable()) {
          bypassRx = true;
          try {
            if (atcForm.requestSubmit) atcForm.requestSubmit();
            else atcForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          } finally {
            setTimeout(function () { bypassRx = false; }, 0);
          }
        }
      });
    }
    var sizeSelect = document.querySelector('.nv-pdp-atc__form [name="id"]');
    // After a size change the theme writes the frame price into the main
    // button; re-render afterwards so it keeps "from …" in a prescription view.
    if (sizeSelect) sizeSelect.addEventListener('change', function () { setTimeout(renderPrices, 0); });

    function apply(state) {
      var rx = state === 'clear';
      isRx = rx;
      if (!rx) rxRoute = '';
      var rp = routeParams();

      buttons.forEach(function (b) {
        var on = b.dataset.rxState === state;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });

      showImageSet(rx ? rxFinish : 'sun');

      // The price itself never changes — the frame costs what it costs in
      // both states. Only the lens-uplift line appears.
      if (rxNote) rxNote.hidden = !rx;
      renderPrices();

      // Tell anything loaded separately (the recommendations row) which view
      // is showing, now and when it changes.
      document.documentElement.setAttribute('data-nv-lens', rx ? 'clear' : 'sun');
      // Read by nv-pdp-info.js on a size change, so the button keeps
      // "Choose lenses" (it used to look for the switch's buttons, removed
      // 2026-10-15).
      toggle.setAttribute('data-rx-active', rx ? '1' : '');
      document.dispatchEvent(new CustomEvent('nv:lens-change', { detail: { rx: rx } }));

      // Accordion content that differs between the two states: the lens
      // spec, and the shipping/returns terms — a made-to-order Rx order is
      // neither dispatched next day nor returnable, so showing the
      // sunglasses terms there would be plainly wrong.
      document.querySelectorAll('[data-lens-state]').forEach(function (node) {
        node.hidden = node.dataset.lensState !== (rx ? 'clear' : 'sun');
      });

      // Colour links carry the view, so picking another colour in the
      // Prescription view opens that colour in the Prescription view too —
      // otherwise every colour change silently drops back to sunglasses.
      document.querySelectorAll('[data-nv-pdp-colorway-item]').forEach(function (a) {
        if (forced) return;
        try {
          var u = new URL(a.getAttribute('href'), window.location.href);
          if (rx) { u.searchParams.set('lens', rxFinish); } else { u.searchParams.delete('lens'); }
          u.searchParams.delete('strength');
          u.searchParams.delete('bluelight');
          Object.keys(rp).forEach(function (k) { u.searchParams.set(k, rp[k]); });
          a.setAttribute('href', u.pathname + u.search);
        } catch (e) { /* URL unsupported — link keeps its plain href */ }
      });

      // Same button, different words. The per-unit price on the button is
      // hidden in the Rx state because the total is not known until the
      // lenses are configured.
      if (atcLabel) atcLabel.textContent = rx ? rxCtaText : atcLabelSun;

      // Sticky bar: label and destination follow the toggle. Its price stays
      // the frame price, matching the block above.
      if (sticky) sticky.setAttribute('data-rx-state', rx ? 'clear' : 'sun');
      if (stickyLabel) stickyLabel.textContent = rx ? rxCtaText : stickyLabelSun;

      // Reflect state in the URL so the choice survives a refresh and can be
      // linked to directly. replaceState rather than pushState: the toggle is
      // a view change, and burying the real previous page under toggle steps
      // would make Back feel broken.
      renderAlt();
      renderCrumb();

      if (forced) return;
      try {
        var url = new URL(window.location.href);
        if (rx) {
          // The finish this view was opened with — clear, or sun for
          // prescription sunglasses (it used to write clear for both, so a
          // refresh of a prescription-sunglasses page came back clear).
          url.searchParams.set('lens', rxFinish);
        } else {
          url.searchParams.delete('lens');
        }
        url.searchParams.delete('strength');
        url.searchParams.delete('bluelight');
        Object.keys(rp).forEach(function (k) { url.searchParams.set(k, rp[k]); });
        window.history.replaceState({}, '', url);
      } catch (e) { /* URL unsupported — state still applies */ }
    }

    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rx-state]');
      if (!btn || forced) return;
      apply(btn.dataset.rxState);
    });

    // In the prescription state both buy buttons must go to the configurator
    // instead of adding the bare frame. Capture phase so these run before
    // the components' own handlers.
    if (stickyBtn && rxUrl) {
      stickyBtn.addEventListener('click', function (e) {
        if (!isRx) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = ctaUrl();
      }, true);
    }

    if (atcForm && rxUrl) {
      atcForm.addEventListener('submit', function (e) {
        if (!isRx || bypassRx) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = ctaUrl();
      }, true);
    }

    // ?lens= arrives from the Optical collections' card links.
    //   lens=clear → prescription state, clear imagery, configurator on Clear
    //   lens=sun   → prescription state, sun imagery,  configurator on Full tint
    // Absent → the ordinary sunglasses PDP, unchanged.
    //
    // Prescription sunglasses is why the image set and the buy path are not
    // the same switch: that state wants sun imagery *and* the Rx route.
    var lens = null;
    try {
      var qs = new URLSearchParams(window.location.search);
      lens = qs.get('lens');
      // Readers have no prescription sunglasses: that view is the glasses one.
      if (reader && lens === 'sun') lens = 'clear';
      if (lens === 'clear' && qs.get('strength') === 'none') {
        rxRoute = qs.get('bluelight') === 'yes' ? 'bluelight' : 'none';
      }
    } catch (e) { /* no param support — falls through to the sun state */ }

    if (forced) {
      rxFinish = 'clear';
      apply('clear');
    } else if (lens === 'clear' || lens === 'sun') {
      // Set the finish before applying: apply() picks the image set from it,
      // so the sun state keeps its sun photography while still taking the
      // prescription route.
      rxFinish = lens;
      apply('clear');
    } else {
      renderAlt();
      renderCrumb();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-nv-rx-toggle]').forEach(init);
    // The Prescription state (from ?lens=) is applied by now: reveal the
    // product area the early script in layout/theme.liquid held back.
    // Also runs on pages without a toggle, so they are never left hidden.
    document.documentElement.classList.remove('nv-rx-pending');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
